import { StarLine } from '@hourly-hds/icons/glyph';
import styles from './TableEmptyState.view.module.css';

const TableEmptyState = () => (
  <div className={styles.emptyState}>
    <StarLine />
    <p>No Data</p>
  </div>
);

export default TableEmptyState;
